function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bubble",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.08 67.64 34.01 58.01 11.14 45.97 25.08 67.64",
    style: {
      fill: "#0250c1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.68 0.21 0.63 7.04 44.39 30.03 57.47 23.08 14.68 0.21",
    style: {
      fill: "#76d1ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.76,40.66,11.11,46l14,21.62-.32-14.56L44.39,63.31V30L.63,7Zm43.62,22.7.14,0-.14-.07Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.39 30.03 44.39 63.36 57.47 56.63 57.47 23.08 44.39 30.03",
    style: {
      fill: "#0250c1"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.0e290bece38a2a12b5a7e84ecfa2664f.svg";
export { ForwardRef as ReactComponent };